export default "__VITE_ASSET__DHReLADr__"